import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import BaseService from "../../../../services/BaseService";
import { useLocation, useNavigate } from "react-router-dom";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import ProjectsService from "../../../../services/ProjectsService";
import MediaCenterService from "../../../../services/MediaCenterService";

const AddProject = () => {
	const [formData, setFormData] = useState({
		title_en: EditorState.createEmpty(),
		title_ar: EditorState.createEmpty(),
		description_en: EditorState.createEmpty(),
		description_ar: EditorState.createEmpty(),
		image: "",
		link: "",
		status: true,
	});
	const location = useLocation();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [typeProject, setTypeProject] = useState(true);
	const [isAdd, setIsAdd] = useState(false);
	const [errors, setErrors] = useState({
		title_en: false,
		title_ar: false,
		description_en: false,
		description_ar: false,
	});
	const lang = useSelector((state) => state.auth.lang);
	const Service = typeProject
		? new ProjectsService()
		: new MediaCenterService();

	useEffect(() => {
		if (location?.pathname.includes("media")) setTypeProject(false);
		let item = location?.state || {};
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				title_en: EditorState.createWithContent(
					ContentState.createFromBlockArray(
						htmlToDraft(item?.title_en?.replaceAll("&lt;", "<"))
					)
				),
				title_ar: EditorState.createWithContent(
					ContentState.createFromBlockArray(
						htmlToDraft(item?.title_ar?.replaceAll("&lt;", "<"))
					)
				),
				description_en: EditorState.createWithContent(
					ContentState.createFromBlockArray(
						htmlToDraft(item?.description_en?.replaceAll("&lt;", "<"))
					)
				),
				description_ar: EditorState.createWithContent(
					ContentState.createFromBlockArray(
						htmlToDraft(item?.description_ar?.replaceAll("&lt;", "<"))
					)
				),
				image: item?.image,
				link: item?.link || "",
			});
		}
	}, []);

	const submit = (e) => {
		e.preventDefault();
		if (
			!draftToHtml(
				convertToRaw(formData?.title_en.getCurrentContent())
			)?.replace("<p></p>\n", "") ||
			!draftToHtml(
				convertToRaw(formData?.title_ar.getCurrentContent())
			)?.replace("<p></p>\n", "") ||
			!draftToHtml(
				convertToRaw(formData?.description_en.getCurrentContent())
			)?.replace("<p></p>\n", "") ||
			!draftToHtml(
				convertToRaw(formData?.description_ar.getCurrentContent())
			)?.replace("<p></p>\n", "")
		) {
			setErrors({
				title_en: !draftToHtml(
					convertToRaw(formData?.title_en.getCurrentContent())
				)?.replace("<p></p>\n", ""),
				title_ar: !draftToHtml(
					convertToRaw(formData?.title_ar.getCurrentContent())
				)?.replace("<p></p>\n", ""),
				description_en: !draftToHtml(
					convertToRaw(formData?.description_en.getCurrentContent())
				)?.replace("<p></p>\n", ""),
				description_ar: !draftToHtml(
					convertToRaw(formData?.description_ar.getCurrentContent())
				)?.replace("<p></p>\n", ""),
			});
			return;
		}
		let data = {
			description_en: draftToHtml(
				convertToRaw(formData?.description_en.getCurrentContent())
			),
			description_ar: draftToHtml(
				convertToRaw(formData?.description_ar.getCurrentContent())
			),
			title_en: draftToHtml(
				convertToRaw(formData?.title_en.getCurrentContent())
			),
			title_ar: draftToHtml(
				convertToRaw(formData?.title_ar.getCurrentContent())
			),
			image: formData?.image,
			link: formData?.link,
		};

		setLoading(true);
		if (isAdd) {
			Service.create(data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						navigate(typeProject ? "/projects" : "/media-center");
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			Service.update(formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						navigate(typeProject ? "/projects" : "/media-center");
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	const fileHandler = (e, name) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		if (!!filesData?.length) {
			new BaseService().postUpload(filesData[0]).then((res) => {
				if (res?.data?.status) {
					setFormData({ ...formData, [name]: res.data.url });
				}
			});
		}
	};

	return (
		<div>
			<AvForm className="form-horizontal add-parking" onValidSubmit={submit}>
				<div>
					<Row>
						<Col md={12} className="mb-3">
							<div className="d-flex align-items-center gap-12">
								<i
									class="las la-arrow-left fs-28 cursor-pointer"
									onClick={() => {
										navigate(typeProject ? "/projects" : "/media-center");
									}}></i>
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang][typeProject ? "project" : "media_center"]}
								</p>
								{/* <Form.Check
									name={`stat`}
									checked={formData?.status}
									type="switch"
									id={`custom-switch`}
								/> */}
							</div>
						</Col>

						{/* Name En */}
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.english_title}
								<span className="star-require">*</span>
							</label>
							<Editor
								editorState={formData?.title_en}
								toolbarClassName="toolbarClassName"
								wrapperClassName="wrapperClassName"
								editorClassName="editorClassName"
								onEditorStateChange={(e) => {
									setFormData((prev) => ({ ...prev, title_en: e }));
									setErrors((prev) => ({ ...prev, title_en: false }));
								}}
							/>
							{errors.title_en && (
								<p className="text-danger m-0" style={{ fontSize: "12.8px" }}>
									{Translate[lang].field_required}
								</p>
							)}
						</Col>
						{/* Name Ar */}
						<Col md={6} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.arabic_title}
								<span className="star-require">*</span>
							</label>
							<Editor
								editorState={formData?.title_ar}
								toolbarClassName="toolbarClassName"
								wrapperClassName="wrapperClassName"
								editorClassName="editorClassName"
								onEditorStateChange={(e) => {
									setFormData((prev) => ({ ...prev, title_ar: e }));
									setErrors((prev) => ({ ...prev, title_ar: false }));
								}}
							/>
							{errors.title_ar && (
								<p className="text-danger m-0" style={{ fontSize: "12.8px" }}>
									{Translate[lang].field_required}
								</p>
							)}
						</Col>
						{/* Description En */}
						<Col md={6} className="mb-3">
							<label className={errors.description_en ? "text-danger" : ""}>
								{Translate[lang]?.english_description}
								<span className="star-require">*</span>
							</label>
							<Editor
								editorState={formData?.description_en}
								toolbarClassName="toolbarClassName"
								wrapperClassName="wrapperClassName"
								editorClassName="editorClassName"
								onEditorStateChange={(e) => {
									setFormData((prev) => ({ ...prev, description_en: e }));
									setErrors((prev) => ({ ...prev, description_en: false }));
								}}
							/>
							{errors.description_en && (
								<p className="text-danger m-0" style={{ fontSize: "12.8px" }}>
									{Translate[lang].field_required}
								</p>
							)}
						</Col>
						{/* Description Ar */}
						<Col md={6} className="mb-3">
							<label className={errors.description_ar ? "text-danger" : ""}>
								{Translate[lang]?.arabic_description}
								<span className="star-require">*</span>
							</label>
							<Editor
								editorState={formData?.description_ar}
								toolbarClassName="toolbarClassName"
								wrapperClassName="wrapperClassName"
								editorClassName="editorClassName"
								onEditorStateChange={(e) => {
									setFormData((prev) => ({ ...prev, description_ar: e }));
									setErrors((prev) => ({ ...prev, description_ar: false }));
								}}
							/>
							{errors.description_ar && (
								<p className="text-danger m-0" style={{ fontSize: "12.8px" }}>
									{Translate[lang].field_required}
								</p>
							)}
						</Col>

						<Col md={6}>
							<label className="text-label">
								{Translate[lang]?.link}
								<span className="star-require">*</span>
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.link}
								bsSize="lg"
								name="link"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.link}
								onChange={(e) =>
									setFormData({
										...formData,
										link: e.target.value,
									})
								}
							/>
						</Col>

						{/* Image */}
						<Col md={6}>
							<label className="text-label mb-0">
								{Translate[lang].image}
								<span className="star-require">*</span>
							</label>
							<div className="upload">
								<input
									type="file"
									name="image"
									id="image"
									onChange={(e) => fileHandler(e, "image")}
								/>
								<p>{Translate[lang].upload_image} / 415*215</p>
								{!formData?.image ? (
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M12 15V3.62"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M15.35 5.85L12 2.5L8.65002 5.85"
											stroke="#0F50A6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								) : (
									<svg
										width="24"
										height="24"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
											fill="#21AA37"
										/>
									</svg>
								)}
							</div>
							{!!formData?.image && (
								<img
									src={formData?.image}
									alt="license_image"
									width={80}
									className="mt-3"
								/>
							)}
						</Col>
					</Row>
				</div>
				<div>
					<Button
						variant="primary"
						type="submit"
						className="w-50 mt-5"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang][typeProject ? "project" : "media_center"]}
					</Button>
				</div>
			</AvForm>
		</div>
	);
};

export default AddProject;
